<template>
  <v-app>
    <v-row no-gutters style="min-height: 100vh">
      <!-- Painel esquerdo -->
      <v-col
        cols="12"
        md="5"
        class="login-brand-panel d-flex align-center justify-center"
      >
        <div class="text-center">
          <img
            src="../../assets/lg_grupo_w.png"
            alt="Logo"
            class="login-brand-logo"
          />
          <p class="login-brand-tagline">Portal Corporativo de Serviços</p>
        </div>
      </v-col>

      <!-- Painel direito -->
      <v-col
        cols="12"
        md="7"
        class="d-flex align-center justify-center login-form-panel"
      >
        <div class="login-form-wrapper">
          <h2 class="login-title">Acesse sua conta</h2>
          <p class="login-subtitle">Informe suas credenciais para continuar</p>

          <v-form
            ref="loginForm"
            v-model="formValid"
            @submit.prevent="handleLogin"
          >
            <v-text-field
              v-model="user.username"
              label="Usuário"
              prepend-inner-icon="mdi-account-outline"
              :rules="requiredRules"
              outlined
              dense
              class="login-input"
            />

            <v-text-field
              v-model="user.password"
              label="Senha"
              prepend-inner-icon="mdi-lock-outline"
              :rules="requiredRules"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="
                showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
              "
              @click:append="showPassword = !showPassword"
              outlined
              dense
              class="login-input"
            />

            <v-btn
              type="submit"
              block
              depressed
              :loading="loading"
              class="login-btn-primary mt-2"
            >
              Entrar
            </v-btn>

            <v-btn
              block
              text
              small
              class="login-btn-link mt-3"
              @click="recuperarSenha"
              :disabled="loading"
            >
              Esqueceu sua senha?
            </v-btn>
          </v-form>
        </div>
      </v-col>
    </v-row>

    <!-- Dialog: Código de Segurança -->
    <v-dialog v-model="alert_token" width="440" persistent>
      <v-card class="login-dialog">
        <v-card-title class="login-dialog__title">
          <v-icon left color="#343f53" size="20">mdi-shield-key-outline</v-icon>
          Código de Segurança
        </v-card-title>

        <v-card-text class="pt-4">
          <v-text-field
            v-model="codigo_seguranca"
            label="Código de Ativação"
            :rules="requiredRules"
            outlined
            dense
            clearable
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="px-4 py-3">
          <v-spacer />
          <v-btn
            text
            small
            @click="alert_token = false"
            class="login-btn-cancel"
          >
            Cancelar
          </v-btn>
          <v-btn
            depressed
            small
            @click="confirmToken()"
            class="login-btn-confirm"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Recuperar Senha -->
    <v-dialog v-model="alert_senha" width="440" persistent>
      <v-card class="login-dialog">
        <v-card-title class="login-dialog__title">
          <v-icon left color="#343f53" size="20">mdi-lock-reset</v-icon>
          Recuperar Senha
        </v-card-title>

        <v-card-text class="pt-4">
          <v-text-field
            v-model="telefoneRS"
            label="Telefone Cadastrado"
            :rules="requiredRules"
            v-mask="'(##) #####-####'"
            outlined
            dense
            clearable
            prepend-inner-icon="mdi-phone-outline"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="px-4 py-3">
          <v-spacer />
          <v-btn
            text
            small
            @click="alert_senha = false"
            class="login-btn-cancel"
          >
            Cancelar
          </v-btn>
          <v-btn
            depressed
            small
            :loading="load_rs"
            @click="confirmRS()"
            class="login-btn-confirm"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Mensagem -->
    <v-dialog v-model="alert_msg" width="400">
      <v-card class="login-dialog">
        <v-card-title class="login-dialog__title">
          <v-icon left color="#343f53" size="20"
            >mdi-information-outline</v-icon
          >
          Mensagem
        </v-card-title>

        <v-card-text class="pt-3 login-dialog__message">
          {{ msg_dialog }}
        </v-card-text>

        <v-card-actions class="px-4 py-3">
          <v-spacer />
          <v-btn
            depressed
            small
            @click="alert_msg = false"
            class="login-btn-confirm"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import User from "../../models/user";
import Usuario from "../../services/usuario";

export default {
  name: "Login",

  data() {
    return {
      formValid: false,
      showPassword: false,
      loading: false,
      load_rs: false,
      alert_token: false,
      alert_senha: false,
      alert_msg: false,
      codigo_seguranca: "",
      telefoneRS: "",
      msg_dialog: "",
      user: new User("", ""),
      requiredRules: [(v) => !!v || "Campo obrigatório"],
      data: {
        email: "",
        senha: "",
        ip: "",
        host: "",
        tipoHost: "3",
        versao: "2.3",
      },
    };
  },

  methods: {
    salva() {
      this.$router.push("/index");
    },

    ativarToken() {
      this.alert_token = true;
    },

    recuperarSenha() {
      this.alert_senha = true;
    },

    confirmToken() {
      Usuario.ativarToken(this.codigo_seguranca)
        .then((response) => {
          this.alert_msg = true;
          this.loading = false;
          this.msg_dialog = response.data.mensagem;
        })
        .catch(() => {
          this.alert_msg = true;
          this.msg_dialog = "Por favor, tente novamente mais tarde.";
        })
        .finally(() => {
          this.alert_token = false;
          this.codigo_seguranca = "";
        });
    },

    confirmRS() {
      this.load_rs = true;
      Usuario.recuperarSenha(this.telefoneRS)
        .then((response) => {
          this.alert_msg = true;
          this.loading = false;
          this.msg_dialog = response.data.mensagem;
        })
        .catch(() => {
          this.alert_msg = true;
          this.msg_dialog = "Por favor, tente novamente mais tarde.";
          this.load_rs = false;
        })
        .finally(() => {
          this.alert_senha = false;
          this.telefoneRS = "";
          this.load_rs = false;
        });
    },

    handleLogin() {
      this.loading = true;
      if (!this.user.username || !this.user.password) {
        this.loading = false;
        this.msg_dialog = "Por favor, preencha todos os campos.";
        this.alert_msg = true;
        return;
      }
      this.$store
        .dispatch("auth/login", this.user)
        .then((response) => {
          if (response == 2) {
            this.alert_msg = true;
            this.loading = false;
            this.msg_dialog = "Por favor, ative seu código de acesso.";
          } else {
            this.showload = true;
            sessionStorage.removeItem("lista_meses_rec");
            this.$router.push("/modulos");
            this.loading = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.alert_msg = true;
          if (error.response && error.response.status === 401) {
            this.msg_dialog = "Usuário ou senha não confere.";
          } else {
            this.msg_dialog = "Falha na conexão com o servidor! Verifique.";
            console.error(error);
          }
        });
    },
  },
};
</script>

<style scoped>
/* ── Brand Panel ── */
.login-brand-panel {
  background: linear-gradient(135deg, #343f53 0%, #3f4d63 100%);
  min-height: 280px;
}

.login-brand-logo {
  width: 80%;
  max-width: 240px;
}

.login-brand-tagline {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875rem;
  margin-top: 16px;
  letter-spacing: 0.5px;
}

/* ── Form Panel ── */
.login-form-panel {
  background-color: #f5f6f8;
}

.login-form-wrapper {
  width: 100%;
  max-width: 380px;
  padding: 40px 24px;
}

.login-title {
  font-size: 1.375rem;
  font-weight: 600;
  color: #343f53;
  margin-bottom: 4px;
}

.login-subtitle {
  font-size: 0.8125rem;
  color: #8a94a6;
  margin-bottom: 32px;
}

.login-input {
  margin-bottom: 4px;
}

/* ── Buttons ── */
.login-btn-primary {
  background-color: #343f53 !important;
  color: #ffffff !important;
  text-transform: none;
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: 0.3px;
  height: 42px !important;
  border-radius: 6px;
}

.login-btn-primary:hover::before {
  opacity: 0.08;
}

.login-btn-link {
  color: #343f53 !important;
  text-transform: none;
  font-weight: 500;
  font-size: 0.8125rem;
  letter-spacing: 0;
}

.login-btn-link:hover {
  text-decoration: underline;
}

/* ── Dialogs ── */
.login-dialog {
  border-radius: 8px !important;
}

.login-dialog__title {
  font-size: 0.9375rem !important;
  font-weight: 600;
  color: #343f53;
  padding: 16px 20px !important;
}

.login-dialog__message {
  font-size: 0.875rem;
  color: #4a5568;
  line-height: 1.5;
}

.login-btn-cancel {
  color: #8a94a6 !important;
  text-transform: none;
  font-weight: 500;
}

.login-btn-confirm {
  background-color: #343f53 !important;
  color: #ffffff !important;
  text-transform: none;
  font-weight: 600;
  border-radius: 4px;
}

/* ── Responsive ── */
@media (max-width: 959px) {
  .login-brand-panel {
    min-height: 180px;
  }

  .login-form-wrapper {
    padding: 32px 20px;
  }
}
</style>
